import { PolicyItem } from '../../../types/interface/claims.interface'

export const sortDocuments = (documents: Array<PolicyItem>) =>
  documents.sort(
    (prevDoc, nextDoc) =>
      new Date(nextDoc.insuredFrom).valueOf() - new Date(prevDoc.insuredFrom).valueOf()
  )
